import { render, staticRenderFns } from "./FormComponentMany.vue?vue&type=template&id=433d0828"
import script from "./FormComponentMany.vue?vue&type=script&lang=js"
export * from "./FormComponentMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports